import React, { useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import NextLink from 'next/link';

import {
  Wrapper,
  Container,
  Col1,
  Col2,
  OfferName,
  OffeExpirationDate,
  OfferDescription,
  OfferContent,
  Section,
  WYSWIGContent,
} from '@components/SingleOffer/styles';

import OfferDetailsBox from '@components/SingleOffer/OfferDetailsBox';
import routes from '@utils/routes';
import { ListDotted } from '@styles/globalStyles';

function SingleOffer({ offer }) {
  const { t } = useTranslation('offers');

  if (!offer || !Object.keys(offer).length) {
    return null;
  }

  return (
    <Wrapper className="single-offer">
      <Container>
        <Col1>
          <NextLink href={routes.offers}>
            <a href={routes.offers} className="link-back" title={t('Back to offers')}>
              {t('Back to offers')}
            </a>
          </NextLink>
          <OfferName>{offer.name}</OfferName>
          <OffeExpirationDate>
            {t('Offer expiration date')}: {offer.stopRecruitment}
          </OffeExpirationDate>
          <OfferContent>
            {offer.employerProfile ? (
              <OfferDescription dangerouslySetInnerHTML={{ __html: offer.employerProfile.description }} />
            ) : null}

            {offer.practiceOffer ? (
              <Section>
                <strong> {t('We Offer')} </strong>
                <WYSWIGContent dangerouslySetInnerHTML={{ __html: offer.practiceOffer }} />
              </Section>
            ) : null}

            <Section>
              <strong> {t('Task range')} </strong>
              <WYSWIGContent dangerouslySetInnerHTML={{ __html: offer.termsOfReference }} />
            </Section>

            {offer.offerSkills && offer.offerSkills.length ? (
              <Section>
                <strong> {t('Requirements')} </strong>
                {/* <p className="subtitle"> {t('We invite you if')} </p> */}

                <ListDotted dotColor="#e6007e">
                  {offer.offerSkills.map((skill) => (
                    <li key={skill.id}>{skill.name}</li>
                  ))}
                </ListDotted>
              </Section>
            ) : null}

            {offer.offerHighschoolPrefs && offer.offerHighschoolPrefs.length ? (
              <Section>
                <strong>Kierunki studiów:</strong>
                <ListDotted dotColor="#e6007e">
                  {offer.offerHighschoolPrefs.map((item) => (
                    <li key={item.id}>
                      {item.highschool.name}: {item.highschoolProfile.name}
                    </li>
                  ))}
                </ListDotted>
              </Section>
            ) : null}

            <Section>
              <strong> {t('Documents needed for the application')} </strong>
              {offer.requireCv && <p>CV</p>}
              {offer.requireLetter && <p>{t('Cover Letter')}</p>}
            </Section>
          </OfferContent>
        </Col1>
        <Col2>
          <OfferDetailsBox offer={offer} />
        </Col2>
      </Container>
    </Wrapper>
  );
}

export default SingleOffer;
